/**
 * The player stats router works for the player stats for the mini-program.
 * The player stats router use the root one as the module scope.
 * It use the tbs.core.AbstractScene as the plugin to improve the development
 * base on the vue framework. It treats the following view as the scene
 * instance.
 *
 * The TBS Scene plugin introduces the properties, mediator, convertor, 
 * translator properties for the built-in meta object.
 *
 * The properties property stands for the context object with the scene view.
 * It contains the title, route, router, bridge* and so on which is used into
 * the mediator.
 *
 * The mediator property stands for the business controller with the scene
 * view. We treat the view as the special component to maintain the whole
 * component-based development pattern. Therefore, it separate the business
 * logic from view to mediator.
 *
 * The convertor property stands for the data convertor between view object
 * and entity object. We treat the data via requesting the service API as the 
 * entity object which is the persistence data and also treat the data via 
 * rendering the UI component as the view object.
 *
 * The translator property stands for the dictionary feature and also acts as the
 * simple version for the i18n module.
 */
const PlayerStatsRouter = {
    path: '/player-stats/report',
    name: 'PlayerStatsReport',
    meta: {
        properties: {
            title: '球员数据',
        },
        mediator: () => import('@/fcl/tbs/controller/PlayerStatsReportMediator'),
        convertor: () => import('@/fcl/tbs/model/vo/icehockey/UserPlayerProfile'),
        translator: () => import('@/fcl/tbs/model/to/icehockey/Stats')
    },
    component: () => import('@/views/player-stats/ReportScene'),
    children: [
        {
            path: 'summary',
            name: 'PlayerStatsReportSummary',
            meta: {
                mediator: () => import('@/fcl/tbs/controller/PlayerStatsReportMediator'), 
                convertor: () => import('@/fcl/tbs/model/vo/icehockey/PlayerStatsSummary'),
                translator: () => import('@/fcl/tbs/model/to/icehockey/Stats')
            },
            component: () => import('@/views/player-stats/ReportSummary'),
        },
        {
            path: 'stats',
            name: 'PlayerStatsReportStats',
            meta: {
                properties: {
                    cached: true,
                },
                mediator: () => import('@/fcl/tbs/controller/PlayerStatsReportMediator'), 
                convertor: () => import('@/fcl/tbs/model/vo/icehockey/PlayerStatsGroup'),
                translator: () => import('@/fcl/tbs/model/to/icehockey/Stats')
            },
            component: () => import('@/views/player-stats/ReportStats'),
        },
        {
            path: 'games',
            name: 'PlayerStatsReportGames',
            meta: {
                mediator: () => import('@/fcl/tbs/controller/PlayerStatsReportMediator'), 
                convertor: () => import('@/fcl/tbs/model/vo/icehockey/PlayerStatsGame'),
                translator: () => import('@/fcl/tbs/model/to/icehockey/Stats')
            },
            component: () => import('@/views/player-stats/ReportGames'),
        }
    ]
}

export default PlayerStatsRouter